export default __webpack_public_path__ + "static/media/diet_history.9034cf94.png";